export default __webpack_public_path__ + "static/media/close-grey.340a55cb.svg";